/* eslint-disable @typescript-eslint/no-explicit-any */
import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type SearchTenantUsersSerializerType = {
  queries: Array<string>;
  searchBy: 'skill' | 'profile';
  includeSelf?: boolean;
  languageCode?: string | null;
  languageProficiencyUid?: number | null;
  timezoneCodes?: Array<string>;
  results: Array<Record<string, any>>;
  count: number;
};

export type SearchAssessedTenantUsersPayloadType = {
  skillDisplayName: number | null;
  level: number | null;
  languageCode: string | null;
  languageProficiencyUid: number | null;
  timezoneCodes: Array<string>;
};

export type SearchReviewedTenantUsersPayloadType = {
  skillDisplayName: number | null;
  skillProficiencyLevel: number | null;
  skillVersatility: number | null;
  languageCode: string | null;
  languageProficiencyUid: number | null;
  timezoneCodes: Array<string>;
  offsetYears: number | null;
  offsetMonths: number | null;
  offsetWeeks: number | null;
  offsetDays: number | null;
};

export type PostSearchTenantUsersPayloadType = (
  Pick<SearchTenantUsersSerializerType, 'queries' | 'searchBy' | 'includeSelf'>
);

export type PostSearchAssessedTenantUserArgsType = (
  PostRequestArgsType<SearchAssessedTenantUsersPayloadType>
);

export type PostSearchReviewedTenantUsersArgsType = (
  PostRequestArgsType<SearchReviewedTenantUsersPayloadType>
);

export const apiSearchTenantUsers = async ({
  domain = useTenantStore().domain,
  payload,
  query = {},
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostSearchTenantUsersPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.searchTenantUsers({ domain }),
      payload,
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiSearchAssessedTenantUsers = async ({
  domain = useTenantStore().domain,
  payload,
  query = {},
  errorConfig = {},
  callbacks = {},
}: PostSearchAssessedTenantUserArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.searchAssessedTenantUsers({ domain }),
      payload,
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiSearchReviewedTenantUsers = async ({
  domain = useTenantStore().domain,
  payload,
  query = {},
  errorConfig = {},
  callbacks = {},
}: PostSearchReviewedTenantUsersArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.searchReviewedTenantUsers({ domain }),
      payload,
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
